// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8qHx6","colMin":"styles_colMin__1CP2L"};